export interface OrderRecordDetail {
  Id: number;
  OrderTime: Date;
  FlowStatus: FlowStatusEnum;
  Passenger: UserInfo;
  StartAddress: string;
  TargetAddress: string;
  AdditionMessage: string;
  TargetAdditionMessage: string;
  BounsAmount: number;
  MeterAmount: number | null;
  ActualAmount: number | null;
  IsComplete: boolean;
  IsCancel: boolean;
  PickupPictureUrl: string;
  GetonTime: Date | null;
  GetoffTime: Date | null;
  ArrivalTime: Date | null;
  TravelTime: number | null;
  PassengerRatingDriver: number;
  PassengerRatingRemark: string;
}

export enum FlowStatusEnum {
  FlowStatus_None = 0,
  FlowStatus_Ready = 1,
  FlowStatus_Arrival = 2,
  FlowStatus_GetOn = 3,
  FlowStatus_GetOff = 4,
  FlowStatus_TaxiFare = 5,
  FlowStatus_Score = 6,
  FlowStatus_DriverCancel = 7,
  FlowStatus_PassengerCancel = 8,
  FlowStatus_NoCars = 9,
  FlowStatus_Mistake = 10,
  FlowStatus_Reassign = 11,
}

export interface UserInfo {
  Id: string;
  Name: string;
  PhoneNumber: string;
}

export enum StatisticsShowType {
  Day = "day",
  Month = "month",
}
